var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{on:{"loggedIn":_vm.loggedIn,"loginFailed":_vm.loginFailed}},[_c('Header',{attrs:{"headerContent":_vm.headerContent},on:{"onLeft":_vm.back}}),_c('CreateGroup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }